import styled from 'styled-components';

export const RadioWrapper = styled.div`
  width: auto;
  margin-right: 40px;
`;
export const TooltipWrapper = styled.span`
  cursor: help;
  margin-left: 5px;
`;

export const NumberInputWrapper = styled.div`
  width: 100%;
`;